import { atom, selector } from 'recoil'
import { abTestState, isValidFormState } from './abtest'

export const pageState = atom({
  key: 'AbTestWizardPageState',
  default: {
    loaded: false,
    loadedStep2: false,
    loadedStep3: false,
    goToWizardStep4: false,
    showLoader: false,
    loading: false,
    error: false,
    wizardStep: 1,
    numberOfStepEnabled: 1,
    severity: 'danger'
  }
})

export const wizardEnableStep1State = selector({
  key: 'AbTestWizardEnableStep1State',
  get: ({ get }) => {
    // const { numberOfStepEnabled } = get(pageState)

    return true
  }
})

export const wizardEnableStep2State = selector({
  key: 'AbTestWizardEnableStep2State',
  get: ({ get }) => {
    const { numberOfStepEnabled } = get(pageState)
    const step1IsValid = get(step1IsValidSate)

    return numberOfStepEnabled >= 2 && step1IsValid
  }
})

export const wizardEnableStep3State = selector({
  key: 'AbTestWizardEnableStep3State',
  get: ({ get }) => {
    const { numberOfStepEnabled } = get(pageState)
    const step1IsValid = get(step1IsValidSate)
    const step2IsValid = get(isValidFormState)

    return numberOfStepEnabled >= 3 && step1IsValid && step2IsValid
  }
})

export const wizardEnableStep4State = selector({
  key: 'AbTestWizardEnableStep4State',
  get: ({ get }) => {
    const { numberOfStepEnabled } = get(pageState)

    return numberOfStepEnabled >= 4 || numberOfStepEnabled === 'only4'
  }
})

export const step1IsValidSate = selector({
  key: 'AbTestWizardstep1IsValidSate',
  get: ({ get }) => {
    const { step1 } = get(abTestState)

    if (!step1.name) {
      return false
    } else if (step1.abTestMessages.length < 2) {
      return false
    } else if (step1.percTest !== 100 && step1.tipoTest === '') {
      return false
    } else {
      return true
    }
  }
})
